export const CodStatusTracking = {
    CSC: 3,
    CRC: 4,
    CRF: 5,
    CPC: 6,
    DAS: 8,
    POD: 7,
    ITI: 14,
    DDP: 11,
    AAV: 12,
    HTS: 10,
    HTB: 1,
    CAC: 2,
    ITL: 13,
    CCC: 9 
}